import type { UserChangeRequestReason } from '@contracts/changeRequest/ChangeRequestContract';
import { OrdersNavigation } from '@src/routing/OrdersNavigation';
import { useNavigate } from 'react-router-dom';

export const useNavigateToCreateChangeRequest = ({
  orderId,
}: {
  orderId: string;
}) => {
  const navigate = useNavigate();

  return {
    navigateToCreateChangeRequest: ({
      reason,
    }: {
      reason: UserChangeRequestReason;
    }) => navigate(OrdersNavigation.changeRequest.url(orderId, reason)),
  };
};
